import type { SearchCookie, SearchCookieParams } from './types';

// ref: da-mamba/Frontend/src/Areas/Mamba/Scripts/SubCookie.ts
export function extractSearchCookieStrings(cookieValue: string | undefined): string[] {
  return (cookieValue ?? '')
    .split('&')
    .map(part => part.substring(part.indexOf('=') + 1))
    .filter(Boolean);
}

// ref: da-mamba/Frontend/src/Areas/Mamba/Scripts/AngularEj/Services/Cookies/SearchCookieBase.ts
export function toSearchCookieString(search: SearchCookie): string {
  return [
    search.originIata,
    search.destinationIata,
    search.outboundDate,
    search.returnDate ?? '',
    search.adults,
    search.children,
    search.infants,
    'False', //Flexi parameter for compatability with other consumers of the cookie eg Staff travel
    search.memberEmail ?? '',
    search.searchId,
    search.searchDate
  ].join('|');
}

// ref: da-mamba/Frontend/src/Areas/Mamba/Scripts/AngularEj/Services/Cookies/SearchCookieBase.ts
export function fromSearchCookieString(search: string): SearchCookie | null {
  const parts = search.split('|');

  if (parts.length < 11 || !parts[2]) return null;

  return {
    originIata: parts[0],
    destinationIata: parts[1],
    outboundDate: parts[2],
    returnDate: parts[3] || undefined,
    adults: parseInt(parts[4]) || 0,
    children: parseInt(parts[5]) || 0,
    infants: parseInt(parts[6]) || 0,
    flexibleOnDates: false,
    memberEmail: parts[8] || undefined,
    searchId: parseInt(parts[9]) || 0,
    searchDate: parts[10]
  };
}

// ref: da-mamba/Frontend/src/Areas/Mamba/Scripts/AngularEj/Services/Cookies/SearchCookieBase.ts
export function areSearchCookiesEqual(a: SearchCookie, b: SearchCookie): boolean {
  return (
    a.originIata === b.originIata &&
    a.destinationIata === b.destinationIata &&
    a.outboundDate === b.outboundDate &&
    a.returnDate === b.returnDate &&
    a.adults === b.adults &&
    a.children === b.children &&
    a.infants === b.infants &&
    a.flexibleOnDates === b.flexibleOnDates &&
    a.memberEmail === b.memberEmail
  );
}

export function buildNewSearchCookie({ outboundDate, returnDate, ...params }: SearchCookieParams): SearchCookie {
  return {
    ...params,
    outboundDate: formatSearchDateTime(outboundDate),
    returnDate: returnDate ? formatSearchDateTime(returnDate) : undefined,
    searchId: 0,
    searchDate: new Date().toISOString().replace('T', ' ')
  };
}

function formatSearchDateTime(date: string): string {
  return date.indexOf('T') === -1 ? date + 'T00:00:00' : date;
}
